import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/core/toast.service';
import * as _moment from 'moment';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  PaymentIntent,
} from '@stripe/stripe-js';
import { LoginService } from 'src/app/core/services/login.service';
import { StripeService, StripeCardNumberComponent, StripeCardExpiryComponent, StripeCardCvcComponent } from 'ngx-stripe';
import { CatalogueService } from 'src/app/modules/dashboard/modules/my-catalogues/services/catalogue.service';
import { PaymentFailComponent } from 'src/app/modules/dashboard/modules/my-catalogues/pages/payment-fail/payment-fail.component';
import { PaymentSuccessComponent } from 'src/app/modules/dashboard/modules/my-catalogues/pages/payment-success/payment-success.component';
import { NextTabService } from 'src/app/modules/sign-up/services/next-tab.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SignupPaymentSuccessComponent } from '../signup-payment-success/signup-payment-success.component';
import { AlertModalComponent } from 'src/app/shared/modules/components/alert-modal/alert-modal.component';
import { PlansService } from 'src/app/modules/dashboard/modules/subscription-plans/services/plans.service';
@Component({
  selector: 'app-signup-plan-payments',
  templateUrl: './signup-plan-payments.component.html',
  styleUrls: ['./signup-plan-payments.component.scss']
})
export class SignupPlanPaymentsComponent implements OnInit {
    planDetails: any;
    billingType:any;
// Card number
isCardNumberVerifying = false;
cardErrorMessage: string | null = null;

// Expiry
isCardExpiryVerifying = false;
expiryErrorMessage: string | null = null;

// CVC
isCardCvcVerifying = false;
cvcErrorMessage: string | null = null;



  numberIsTouched = false;
  expiryIsTouched = false;
  cvcIsTouched = false;
  numberIsValid = false;
  expiryIsValid = false;
  cvcIsValid = false;

 
  @ViewChild(StripeCardNumberComponent) card!: StripeCardNumberComponent;
  @ViewChild(StripeCardExpiryComponent) cardExpiry!: StripeCardExpiryComponent;
  @ViewChild(StripeCardCvcComponent) cardCvc!: StripeCardCvcComponent;

  subObj = {
    dental_supplier_id: null,
    dental_professional_id: null,
    dental_practice_id: null,
    subscription_plan_id: null,
    //client_id:null,
    //tenure_in_days:null,
    starts_at: null,
    expires_at: null,
    //status:null,
    plan_type: null,
    total_amount: null
  }

  userDetails: any;

  // cardOptions: StripeCardElementOptions = {
  //   style: {
  //     base: {
  //       iconColor: '#666EE8',
  //       color: '#31325F',
  //       fontWeight: '300',
  //       fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
  //       fontSize: '18px',
  //       '::placeholder': {
  //         color: '#CFD7E0',
  //       },
  //     },
  //   },
  // };

  // elementsOptions: StripeElementsOptions = {
  //   locale: 'es',
  // };

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: 'Helvetica Neue, Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': { color: '#CFD7E0' },
      },
    },
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };



  // stripeTest = this.fb.group({
  //   name: ['Angular v10', [Validators.required]],
  //   amount: [1001, [Validators.required, Validators.pattern(/\d+/)]],
  // });

  stripeTest: FormGroup;
  stripe_customer_id: any;
  payUserDetails: unknown;

  constructor(private _dialogRef: MatDialogRef<SignupPlanPaymentsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: any
      planDetails: any
      type: any;
      billingType:any
      // tableName: string;
      // id: string;
      // message: string;
      // hintText: string;
      // status: string
    }, private catalogueService: CatalogueService,
    private toast: ToastService,
    private fb: FormBuilder,
    private loginService:LoginService,
    private stripeService: StripeService,
    private nextTabService: NextTabService,
    private dialog: MatDialog,
    private plansService: PlansService,
    private spinner: NgxSpinnerService,) {
        this.planDetails = data.planDetails; 
        this.billingType = data.billingType;
        // <-- now available in this component
    }

  ngOnInit(): void {
    this.userDetails = this.loginService.getLoginData();
    this.stripeTest = this.fb.group({
      name: [this.userDetails.name, [Validators.required]],
      email: [this.userDetails.email, [Validators.required, Validators.email]],
    });
  }

  dialogClose() {

    // this._dialogRef.close()
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp");
    setTimeout(() => { this._dialogRef.close(); }, 1000);

  }


  // numberChange(number: any) {
  //   this.numberIsTouched = true;
  //   this.numberIsValid = (!!!number.error &&
  //     number.complete);
  // }
  // cvcChange(cvc: any) {
  //   this.cvcIsTouched = true;
  //   this.cvcIsValid = (!!!cvc.error &&
  //     cvc.complete);
  // }
  // expiryChange(expiry: any) {
  //   this.expiryIsTouched = true;
  //   this.expiryIsValid = (
  //     !!!expiry.error &&
  //     expiry.complete);
  // }

numberChange(event: any) {
  this.numberIsTouched = true;

  // If Stripe reports an error immediately → stop loader, show error
  if (event.error) {
    this.isCardNumberVerifying  = false;
    this.numberIsValid = false;
    this.cardErrorMessage = event.error.message; // capture actual message
    return;
  }

  // If still typing but no error yet → show loader, hide error
  if (!event.complete) {
     this.isCardNumberVerifying  = true;
    this.numberIsValid = false;
    this.cardErrorMessage = null; // no error yet
    return;
  }

  // Finished and valid → stop loader, mark valid
    this.isCardNumberVerifying  = false;
  this.numberIsValid = true;
  this.cardErrorMessage = null;
}
expiryChange(event: any) {
  this.expiryIsTouched = true;

  if (event.error) {
    this.isCardExpiryVerifying  = false;
    this.expiryIsValid = false;
    this.expiryErrorMessage = event.error.message;
    return;
  }

  if (!event.complete) {
    this.isCardExpiryVerifying  = true;
    this.expiryIsValid = false;
    this.expiryErrorMessage = null;
    return;
  }

  this.isCardExpiryVerifying  = false;
  this.expiryIsValid = true;
  this.expiryErrorMessage = null;
}

  
cvcChange(event: any) {
  this.cvcIsTouched = true;

  if (event.error) {
    this.isCardCvcVerifying  = false;
    this.cvcIsValid = false;
    this.cvcErrorMessage = event.error.message;
    return;
  }

  if (!event.complete) {
    this.isCardCvcVerifying  = true;
    this.cvcIsValid = false;
    this.cvcErrorMessage = null;
    return;
  }

  this.isCardCvcVerifying  = false;
  this.cvcIsValid = true;
  this.cvcErrorMessage = null;
}

  async completePayment() {
    // if(!this.selectedAddress){
    //   this.toast.openSnackBar('Please select shipping address');
    //   return;
    // }

    if (this.stripeTest.invalid) {
      this.toast.openSnackBar('Enter payment details');
      return;
    }

    if (!(this.numberIsValid && this.expiryIsValid && this.cvcIsValid)) {
      this.numberIsTouched = true;
      this.expiryIsTouched = true;
      this.cvcIsTouched = true;
      //this.toast.openSnackBar('Enter valid payment details');
      this.stripeTest.markAllAsTouched();
      return;
    }


    this.spinner.show()

    console.log('Payment part--->', this.data)
    if (this.data.planDetails.type == "PROFESSIONAL") {
      this.nextTabService.getUserProf(this.data.leadId).subscribe((userdata: any) => {
        console.log('Payment User Info-->', userdata)
        this.payUserDetails = userdata;
        this.stripe_customer_id = userdata.stripe_customer_id;
      });

      this.subObj.dental_professional_id = this.data.leadId

      delete this.subObj.dental_supplier_id
      delete this.subObj.dental_practice_id


    }

    if (this.data.planDetails.type == "SUPPLIER") {
      this.nextTabService.getUserSupplier(this.data.leadId).subscribe((userdata: any) => {
        console.log('Payment User Info-->', userdata)
        this.payUserDetails = userdata;
        this.stripe_customer_id = userdata.stripe_customer_id;
      });

      this.subObj.dental_supplier_id = this.data.leadId

      delete this.subObj.dental_professional_id
      delete this.subObj.dental_practice_id


    }

    if (this.data.planDetails.type == "PRACTICE") {
      this.nextTabService.getUserPractice(this.data.leadId).subscribe((userdata: any) => {
        console.log('Payment User Info-->', userdata)
        this.payUserDetails = userdata;
        this.stripe_customer_id = userdata.stripe_customer_id;
      });

      this.subObj.dental_practice_id = this.data.leadId

      delete this.subObj.dental_supplier_id
      delete this.subObj.dental_professional_id

    }

    this.subObj.subscription_plan_id = this.data.planDetails.id

    this.subObj.starts_at = _moment().toDate();
    this.subObj.expires_at = _moment().add(this.data.planDetails.tenure_in_days == 0?30:this.data.planDetails.tenure_in_days, 'd').toDate();
    //this.subObj.status =  "PENDING"
    this.subObj.plan_type = this.data.planDetails.plan_type
    this.subObj.total_amount = this.data.planDetails.monthy_price ? this.data.planDetails.monthy_price : 0;

    try {
      // Step 1: Create Payment Method
      const name = this.stripeTest.get('name')?.value;
      const email = this.stripeTest.get('email')?.value;

      const result = await this.stripeService.createPaymentMethod({
        type: 'card',
        card: this.card.element,
        billing_details: { name, email }
      }).toPromise();

      if (!result || !result.paymentMethod) {
        this.toast.openSnackBar(result?.error?.message || 'Payment method creation failed');
        this.spinner.hide();
        return;
      }

      const paymentMethodId = result.paymentMethod.id;

      // Step 2: Create subscription via backend
      // const response = await this.catalogueService.addNextSub({
      //   ...this.subObj,
      //   payment_method_id: paymentMethodId
      // }).toPromise();

      const response = await this.catalogueService.createSubscription(
        email,
        name,
        paymentMethodId,
        this.data.planDetails.stripe_price_id // <--- IMPORTANT
      ).toPromise();

      // Backend must return client_secret
      const clientSecret = response.clientSecret;
      const customerId = response.customerId;
      const subscriptionId = response.subscriptionId;

      if(this.data.type === 'addcard') {

        // Step 3: Confirm Payment
        const paymentResponse = await this.stripeService.confirmCardPayment(clientSecret, {
          payment_method: paymentMethodId
        }).toPromise();
        console.log("Update subscriptionId", subscriptionId)
        console.log("paymentResponse 1", paymentResponse);

        this.spinner.hide();

        if (paymentResponse?.error) {
          this._dialogRef.close();
          this.dialog.open(PaymentFailComponent, {
            panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
            width: '30%'
          });
        } else if (paymentResponse?.paymentIntent?.status === 'succeeded') {
            this.plansService.getSubscriptionPlanById(this.data.planDetails.id).subscribe(
            (data) => {
            console.log("plan Data", data.permissions);

      // ✅ Now update login data with subscription_permissions
      this.loginService.updateLoginData({
        payment_completed: true,
        plan_id: this.data.planDetails.id,
        subscription_permissions: data.permissions // <-- added field
      });

      console.log("Updated loginData:", this.loginService.getLoginData());

      this.spinner.hide();
    },
    (error) => {
      this.spinner.hide();
      this.toast.openSnackBar('Failed to load plan details');
    }
  );

  if (this.data.planDetails.type == "PROFESSIONAL") {
    this.nextTabService.updateProfessionalStripe(this.data.leadId, customerId, this.data.planDetails.id)
      .subscribe(res => console.log('Professional Stripe ID Updated:', res));
  }

  if (this.data.planDetails.type == "SUPPLIER") {
    this.nextTabService.updateSupplierStripe(this.data.leadId, customerId, this.data.planDetails.id)
      .subscribe(res => console.log('Supplier Stripe ID Updated:', res));
  }

  if (this.data.planDetails.type == "PRACTICE") {
    this.nextTabService.updatePracticeStripe(this.data.leadId, customerId, this.data.planDetails.id)
      .subscribe(res => console.log('Practice Stripe ID Updated:', res));
  }

  const response = await this.catalogueService.addNextSub({
    ...this.subObj,
    stripe_subscription_id: subscriptionId,
    payment_intent: paymentResponse,
    plan_status: "ACTIVE"
  }).toPromise();

  console.log("✅ Payment + Subscription Response:", response);
  this._dialogRef.close();
  this.dialog.open(SignupPaymentSuccessComponent, {
    panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
    width: '30%'
  });
}

      }
      if(this.data.type === 'updatecard') {
        // 2. Send to backend to update Stripe customer + subscriptions
          this._dialogRef.close();
        this.catalogueService.updateCard(customerId, paymentMethodId)
        .subscribe({
          next: (res) => {
            console.log(res.message);


            this.dialog.open(AlertModalComponent, {
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        width: '500px',
        data: {
          title: 'Success',
          message: 'Card updated successfully!',
          type: 'success'
        }
      });
     // alert('Card updated successfully!');
          },
          error: (err) => {
            console.error('Error updating card:', err);
            alert('Failed to update card');
          }
        });
      }
      this.spinner.hide();
    } catch (error: any) {
      console.error(error);
      this.toast.openSnackBar('Payment failed. Try again.');
      this.spinner.hide();
    }

  }

  
  close() {
    this._dialogRef.close();
  }

}
